    <template>
        <div class="footer-bg">
            <div class="container">
                <div class="footer">
                    <div class="foot-1">
<!--                        <div class="foot1_1">-->
<!--                            <div class="logo">-->
<!--                              <router-link to="/">-->
<!--                                <img src="@/assets/img/logo.png" alt="">-->
<!--                              </router-link>-->
<!--                            </div>-->
<!--                            <div class="menu">-->
<!--                                <ul>-->
<!--                                    <li><router-link to="/">{{$t('main')}}</router-link></li>-->
<!--                                    <li><router-link to="/about">{{$t('about')}}</router-link></li>-->
<!--                                    <li><router-link to="/services">{{$t('our_services')}}</router-link></li>-->
<!--                                    <li><router-link to="/guide">{{$t('guide')}}</router-link></li>-->
<!--                                </ul>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="foot1_2">
                            <div class="mars">
                                <a href="https://mars.studio/" target="_blank"><img src="@/assets/img/logo_mars.svg" alt=""> <span>{{$t('developed')}}</span></a>
                            </div>
<!--                            <div class="text">{{$t('seif')}}</div>-->
                        </div>
                        <div>
                        </div>
                    </div>
                    <div class="foot-2">
                        <a href="https://apps.apple.com/app/id1197151536" target="_blank"><img src="@/assets/img/appStore.svg" alt=""></a>
                        <a href="https://play.google.com/store/apps/details?id=mars.lombard" target="_blank"><img src="@/assets/img/googlePlay.svg" alt=""></a>
                    </div>
                </div>
            </div>
        </div>
    </template>

<script>
export default {
  name: 'footerComponent',
  data () {
    return {

    }
  }
}
</script>
    <style scoped>

    </style>



// WEBPACK FOOTER //
// src/components/footerComponent.vue